import React, { useEffect } from "react";

import "./style.scss";
import { Dialog } from "../../components";
import globalStore from "../globalStore";
import { initWxCode } from "../../utils/wx_tools";
import syncedLogo from "../../assets/images/synced-log.png";

const WxLoginDialog = () => {
  const { dialog, setDialog } = globalStore();
  const onCancel = () => setDialog("wx-login", false);

  const initCode = () => {
    initWxCode();
  };

  useEffect(() => {
    if (dialog["wx-login"]) {
      initCode();
    }
  }, [dialog["wx-login"]]);

  // const retryScanCode = () => {
  //   initCode();
  // };

  return (
    <Dialog
      visible={dialog["wx-login"]}
      style={{ padding: 0, border: 0 }}
      onCancel={onCancel}
      closeable={false}
    >
      <div className="wx-login-dialog">
        <img src={syncedLogo} alt="logo" />
        <p className="title">
          微信扫码<span>一键登录</span>
        </p>
        <p className="p-1">未注册的微信号将自动创建成机器之心新账号</p>
        <div id="code-node" />
        <p className="p-2">
          扫码登录即代表我已阅读并同意{" "}
          <a
            href="https://www.jiqizhixin.com/short_urls/f7dd70ed-41d4-47c0-ad8f-5871ed7a03c8"
            target="_blank"
            rel="noreferrer"
          >
            《用户协议》
          </a>
        </p>
      </div>
    </Dialog>
  );
};

export default WxLoginDialog;
